import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Sun, Moon, ArrowRight, Menu, X } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const nav = [
  { to: '/', label: 'home' },
  { to: '/about', label: 'about me' },
  { to: '/experience', label: 'experience' },
  { to: '/writing', label: 'writing' },
  { to: '/growth', label: 'growth' },
  { to: '/credentials', label: 'credentials' },
  { to: '/contact', label: 'contact' }
];

const Header = () => {
  const { theme, toggle } = useTheme();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-background/70 border-b border-border/40">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group">
          <span className="w-2 h-2 rounded-full bg-brand pulse-dot" />
          <span className="font-semibold tracking-tight text-[15px]">
            Veeresh <span className="text-ink-mute font-normal">Wali.</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-7 text-[13.5px] text-ink-soft">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === '/'}
              className={({ isActive }) => `nav-link hover:text-foreground transition-colors ${isActive ? 'active text-foreground' : ''}`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            aria-label="Toggle theme"
            onClick={toggle}
            className="w-10 h-10 rounded-full border border-border flex items-center justify-center hover:bg-brand/10 hover:shadow-md hover:-translate-y-0.5 transition-all"
          >
            {theme === 'dark' ? <Sun size={16} /> : <Moon size={16} />}
          </button>
          <Link
            to="/contact"
            className="hidden sm:inline-flex items-center gap-2 pl-4 pr-3 h-10 rounded-lg bg-brand text-black font-medium text-[13.5px] hover:bg-brand-2 transition-colors"
          >
            Get in Touch <ArrowRight size={15} />
          </Link>
          <button
            className="md:hidden w-10 h-10 rounded-full border border-border flex items-center justify-center hover:bg-brand/10 hover:shadow-md hover:-translate-y-0.5 transition-all"
            onClick={() => setOpen((o) => !o)}
            aria-label="Menu"
          >
            {open ? <X size={16} /> : <Menu size={16} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-border/40 bg-background">
          <nav className="px-6 py-4 flex flex-col gap-3 text-sm">
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === '/'}
                onClick={() => setOpen(false)}
                className={({ isActive }) => `py-1 ${isActive ? 'text-foreground' : 'text-ink-soft'}`}
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
